import type { BoxProps } from "@chakra-ui/react";
import { createContext } from "react";

interface IHorizontalSliderContext {
  itemWidth: BoxProps["width"];
}

export const HorizontalSliderContext = createContext(
  {} as IHorizontalSliderContext,
);
